<div class="width-100 exchange-container" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="36px">
    <app-header [withBanner]="true" [link]="landingPageLink" class="width-100"></app-header>
    <app-animated-blurred-circles></app-animated-blurred-circles>
    <div class="not-design-system rs-wrapper-v4">
        <div class="grid col2 col1-sm container-hero">
            <div class="container-text">
                <h1 [innerHTML]="'title_exchange' | translate: {
                    element_one: sendSystem.attributes.alternative_name,
                    element_two: receiveSystem.attributes.alternative_name
                }"></h1>
                <p class="text-simple">{{'subtitle_exchange' | translate}}</p>
                <ol>
                    <li>{{'step_one_exchange' | translate}}</li>
                    <li>{{'step_two_exchange' | translate}}</li>
                    <li [innerHTML]="'step_three_exchange' | translate: {
                        element: transaction.relationships.system2.data!.attributes.alternative_name
                    }">{{'step_three_exchange' | translate}}</li>
                </ol>
            </div>
            <section class="width-100 padding-bottom-0" fxLayout="column" fxLayoutAlign="center center"
                fxLayoutGap="16px">
                <app-transaction-calculator *appShellNoRender [transaction]="transaction" [systems$]="systems$"
                    [actionButtonText]="'Crear pedido'">
                </app-transaction-calculator>
                <app-calculator-skeleton *appShellRender></app-calculator-skeleton>
            </section>
        </div>
        <app-info-block [titleBlock]="'titleExchange' | translate: {element: darkTitle}"
            title="{{ 'titleExchange' | translate: {element: darkTitle} }}">
            <div *ngIf="(sendSystem.id && receiveSystem.id) && platformBrowserService.isBrowser">
                <app-series-chart [chartSettings]='settingsChart'></app-series-chart>
            </div>
        </app-info-block>

        <app-currency-comparison [transaction]="transaction"></app-currency-comparison>
        <app-fee-banner [transaction]="transaction"></app-fee-banner>

        <div class="container-best-price-tables" [attr.id]="'best-price-tables-id'">
            <app-best-price-tables [system1]="sendSystem" [system2]="receiveSystem"></app-best-price-tables>
        </div>
    </div>
</div>

<app-flyer-saldo backgroundImage="../../../../assets/landing-social-proof/flyer2.svg">
    <div class="container-flyer">
        <h2 class="title-flyer">¡Aprovecha y atrapa ofertas<br>para ahorrar hasta un 5%!</h2>
        <button class="mat-button" routerLink="">Crear pedido</button>
    </div>
</app-flyer-saldo>

<app-systems-recommendations [system1]="sendSystem" [system2]="receiveSystem"
    [systems]="systems"></app-systems-recommendations>

<app-footer class="width-100 not-panel"></app-footer>
